import React, { useEffect } from "react";
import { Radio } from "@mantine/core";
import { Controller, useFormContext } from "react-hook-form";
import { current } from "@reduxjs/toolkit";

const ClaimDetails = ({ setActive, setTemporaryOpened }) => {

  const { control, watch, setValue, formState: { errors }, trigger } = useFormContext();

  const type_of_claim = watch('type_of_claim');
  const validClaimTypes = [
    "delayed",
    "cancelled",
    "denied_boarding",
    "lost/damaged",
    "lost_wages",
    "other",
  ];





  useEffect(() => {
    if (type_of_claim && validClaimTypes.includes(type_of_claim)) {
      localStorage.setItem("claimType", type_of_claim);
    }
  }, [type_of_claim, validClaimTypes]);

  const handleNext = async () => {
    const isValid = await trigger([
      "type_of_claim",
    ]);

    if (!isValid) {
      return;
    }

    if (type_of_claim === 'lost/damaged' || type_of_claim === 'lost_wages') {
      setValue('required_actual_flight', 'yes');
      setActive(current => current + 2);
    } else {
      setActive(current => current + 1);
    }
  }


  return (
    <div className="select-claim-type stepper-container">
      <h3 className="stepper-header">Claim details</h3>

      <div>
        <h4 className="stepper-sub-header">
          What happened to your flight?
          <span style={{ color: "red" }}> *</span>
        </h4>
        <div className="radio-options-wrapper">
          <Controller
            name="type_of_claim"
            control={control}
            rules={{ required: "Please select an option" }}
            render={({ field }) => (
              <Radio.Group
                value={field.value}
                onChange={(value) => {
                  field.onChange(value);

                }}
              >
                <Radio
                  color="red"
                  variant="outline"
                  value="delayed"
                  label="Flight delayed (3+ hours)"
                />
                <Radio
                  color="red"
                  variant="outline"
                  value="cancelled"
                  label="Flight cancelled (Not applicable if alternative flight was provided by Airline)"
                />
                <Radio
                  color="red"
                  variant="outline"
                  value="denied_boarding"
                  label="Denied boarding"
                />
                <Radio
                  color="red"
                  variant="outline"
                  value="lost/damaged"
                  label="Lost/damaged/delayed baggage"
                />
                <Radio
                  color="red"
                  variant="outline"
                  value="lost_wages"
                  label="Lost Wages"
                />
                <Radio
                  color="red"
                  variant="outline"
                  value="other"
                  label="Other issue"
                />
              </Radio.Group>
            )}
          />
          {errors.type_of_claim && (
            <p style={{ color: "red", marginTop: "10px" }}>
              {errors.type_of_claim.message}
            </p>
          )}
        </div>
      </div>

      <div className="stepper-btn-wrapper">
        <button className="secondary-btn new-back-btn" type="button" onClick={() => setActive(c => c - 1)} >
          Back
        </button>

        <div className="add-btn-wrapper" >

          <button className="secondary-btn" type="button" onClick={() => setTemporaryOpened(true)}>
            Temporary Save
          </button>

          <button onClick={handleNext} className="primary-btn" type="button">
            Next
          </button>




        </div>
      </div>



    </div>
  );
};

export default ClaimDetails;
